import * as React from 'react';
import styled from 'styled-components';
import * as constants from '@latitude/core/utils/constants';
var StyledBold = /*#__PURE__*/styled.b.withConfig({
  displayName: "Bold__StyledBold",
  componentId: "sc-10z0i54-0"
})(["font-weight:", ";"], constants.FONT_WEIGHT.BOLD);

var Bold = function Bold(props) {
  return /*#__PURE__*/React.createElement(StyledBold, props, props.children);
};

var Strong = function Strong(props) {
  return /*#__PURE__*/React.createElement(Bold, Object.assign({}, props, {
    as: "strong"
  }));
};

export { Bold, Strong };